/**
 * Функция которая принимает массив и делит его на части размером второго параметра.
 *
 * @param {any[]} arr - Массив любых типов
 * @param {number} size - Количество элементов при достижении которого массив будет делиться
 * @return {any[][]} Массив массивов разделенных по параметру size
 *
 * @example
 *
 *     splitArrayOnChunks(["Один", "Два, "Три"], 1)
 *     // [[Один], [Два], [Три]]
 */
export const splitArrayOnChunks = (arr: any[], size: number): any[][] => {
  return arr.reduce(
    (acc, e, i) => (
      i % size ? acc[acc.length - 1].push(e) : acc.push([e]), acc
    ),
    []
  );
};

export const capitalizeFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
